import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import AppToolBar from '~/components/AppToolBar';
import Page from '~/components/Page.jsx';

const useStyles = makeStyles({
  root: {
    minHeight: '80vh',
  },
});

function RestaurantAppDownload() {
  const classes = useStyles();
  return (
    <Page name='restaurant-app-download'>
      <AppToolBar />
      <Grid container justify='center' className={classes.root}>
        <Grid item xs={10} sm={8}>
          <Typography align='center' paragraph variant='h3'>
            <b>Restaurant App Download</b>
          </Typography>
          <Divider style={{ margin: '60px 0' }} />
          <Grid container>
            <Grid item xs={12} sm={3}>
              <Typography variant='h4'>iOS APP</Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Button
                variant='contained'
                size='large'
                color='primary'
                style={{ borderRadius: 300, height: 60 }}
                href='itms-services://?action=download-manifest&url=https://static-cache.chowbus.com/app-download/restaurant-ios/manifest.plist'>
                TAP HERE TO DOWNLOAD
              </Button>
              <Typography variant='subtitle2' style={{ marginTop: 40 }}>
                First Time Install Instructions
              </Typography>
              <List component='ol' style={{ listStyleType: 'decimal', paddingLeft: 20 }}>
                <ListItem style={{ display: 'list-item' }}>
                  <Typography variant='subtitle2'>Download the app linked above</Typography>
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <Typography variant='subtitle2'>
                    Go to Settings -> General -> Profile and Device Management -> Fantuan Group ->
                    Trust
                  </Typography>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Divider style={{ margin: '60px 0' }} />
        </Grid>
      </Grid>
    </Page>
  );
}

export default RestaurantAppDownload;
